import { useQuery } from 'react-query';
import { cartService } from 'services';
import { ServerStateKeysEnum } from '../constants';

export const useRetriveCart = () => {
  return useQuery(
    `${ServerStateKeysEnum.userCurrentCart}`,
    () => {
      return cartService.createCart();
    },
    {
      staleTime: Infinity,
    }
  );
};
